/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */
// 假设有三个环境变量
const ENV = {
  DEV: 'development',
  TEST: 'test',
  PROD: 'production'
};

// 根据当前环境动态设置API URL
// 后台管理系统服务器地址
const getBaseUrl = () => {
  switch (process.env.NODE_ENV) {
    case ENV.DEV:
      return '/api';//https://192.168.3.3:444/api使用IP地址会出现跨域访问的问题，使用nginx解决跨域，按照nginx配置，实际上会跳转到https://192.168.3.3:8001
    case ENV.TEST:
      return '/api';
    case ENV.PROD:
      return '/api';
    default:
      throw new Error('Unknown environment');
  }
};

// 系统数据备份还原服务器地址
const getBackupBaseUrl = () => {
  switch (process.env.NODE_ENV) {
    case ENV.DEV:
      return 'http://192.168.3.3:8002';
    case ENV.TEST:
      return 'http://10.0.12.5:8002';
    case ENV.PROD:
      return 'http://10.0.12.5:8002';
    default:
      throw new Error('Unknown environment');
  }
};

// 报表服务器地址
const getReportUrl = () => {
  switch (process.env.NODE_ENV) {
    case ENV.DEV:
      return '/reportUrl';
    case ENV.TEST:
      return '/reportUrl';
    case ENV.PROD:
      return '/reportUrl';
    default:
      throw new Error('Unknown environment');
  }
};

// Excel导入web服务器地址
const getImportExcelUrl = () => {
  switch (process.env.NODE_ENV) {
    case ENV.DEV:
      return 'http://192.168.3.2/WebImportExcel/';
    case ENV.TEST:
      return 'http://10.0.12.5/WebImportExcel/';
    case ENV.PROD:
      return 'http://10.0.12.5/WebImportExcel/';
    default:
      throw new Error('Unknown environment');
  }
};

// // 后台管理系统服务器地址
// export const baseUrl = 'http://192.168.3.3:8001'
// // 系统数据备份还原服务器地址
// export const backupBaseUrl = 'http://localhost:8002'
// // 报表服务器地址
// export const reportUrl = 'http://192.168.3.2/ReportServer_WMS/Pages/ReportViewer.aspx?%2fWMS%2f'
// // Excel导入web服务器地址
// export const importExcelUrl = 'http://192.168.3.2/WebImportExcel/'

export default {
    baseUrl:getBaseUrl(),
    backupBaseUrl:getBackupBaseUrl(),
    reportUrl:getReportUrl(),
    importExcelUrl:getImportExcelUrl()
}



// WEBPACK FOOTER //
// ./src/utils/global.js